import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import {
  confirmed,
  email,
  min,
  min_value,
  max_value,
  numeric,
  required,
} from 'vee-validate/dist/rules';
import CpfValidate from './utils/identity';
import { toFixedCurrency }  from './utils/functions';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


// In order to validations work, we must declare/import which rules we want use.
// extend('rule_name', rule_imported)

extend('confirmed', {
  ...confirmed,
  message: 'A confirmação não confere.'
});

extend('required', {
  ...required, // Adding all the object props of imported rule.
  message: 'O campo é obrigatório' // Overriding the message.
});

extend('min', {
  ...min,
  message(field, { length }) {
    return 'O campo deve conter pelo menos ' + length + ' caracteres';
  }
});

extend('numeric', {
  ...numeric,
  message: 'Somente números são aceitos'
});

extend('email', {
  ...email,
  message: 'O campo deve ser um e-mail válido'
});

extend('min_value', {
  ...min_value,
  message(field, { min }) {
    return 'O valor deve ser maior que ' + toFixedCurrency(min) + " R$" ;
  }
});

extend('min_percentage', {
  ...min_value,
  message(field, { min }) {
    return 'O valor deve ser maior que ' + toFixedCurrency(min) + "%" ;
  }
});

extend('max_value', {
  ...max_value,
  message(field, { max }) {
    return 'O valor deve ser menor que ' + toFixedCurrency(max) + " R$" ;
  }
});

extend('max_percentage', {
  ...max_value,
  message(field, { max }) {
    return 'O valor deve ser menor que ' + toFixedCurrency(max) + "%" ;
  }
});

extend('identity', {
  validate: value => CpfValidate(value),
  message(field) {
    return 'O CPF informado é inválido';
  }
});


// WEBPACK FOOTER //
// ./src/vee-validate.js